import { Pipe, PipeTransform } from '@angular/core';
import { ReceitaDto } from '../models/receita-dto';

@Pipe({
  name: 'receitasPipe'
})
export class ReceitasPipe implements PipeTransform {
  transform(receitas: ReceitaDto[]): string[] {
    return receitas?.map(receita => {
      if (receita == null) {
        return "";
      }

      return formataCodigoReceita(receita.codigo) + " - " + receita.descricao;
    });
  }
}

/*** PROTÓTIPO ***/
function formataCodigoReceita(codigo: number): string{
  let retorno = '';
  const totDigitos = codigo.toString().length;
  switch (totDigitos){
    case 1:  retorno = "000" + codigo.toString(); break;
    case 2:  retorno = "00"  + codigo.toString(); break;
    case 3:  retorno = "0"   + codigo.toString(); break;
    default: retorno = codigo.toString(); break;
  }
  return retorno
}